/**
 * @name          jQuery parsleyValidators Plugin
 * @version       0.1
 * @lastmodified  2016-05-31
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        CH, VI
 *
 * based on: http://jqueryboilerplate.com/
 */

;(function ($) {
	'use strict';

	// methods
	var methods = {
		init: function () {
			if(global.configuration.get('parsleyValidatorsInitialized') !== true) {
				var self = this;
				self.maxFileSize();
				self.fileExtension();
				self.date();
				self.minAge();
				self.maxDate();
				self.minDate();
				self.iban();
				self.checkCaptchaUrl();
				self.isWeekend();
				self.excludeDates();
				self.zipcode();
				self.zipcodeList();

				Parsley.addMessages('de', {
					defaultMessage: 'Die Eingabe scheint ungültig zu sein.',
					type: {
						email: 'Die Eingabe muss eine gültige E-Mail-Adresse sein.',
						url: 'Die Eingabe muss eine gültige URL sein.',
						number: 'Die Eingabe muss eine Zahl sein.',
						integer: 'Die Eingabe muss eine ganze Zahl sein.',
						digits: 'Die Eingabe muss eine Ziffer sein.',
						alphanum: 'Die Eingabe muss alphanumerisch sein.'
					},
					notblank: 'Die Eingabe darf nicht leer sein.',
					required: 'Bitte füllen Sie dieses Pflichfeld aus.',
					pattern: 'Die Eingabe scheint ungültig zu sein.',
					// min:            'This value should be greater than or equal to %s.',
					// max:            'This value should be lower than or equal to %s.',
					// range:          'This value should be between %s and %s.',
					minlength: 'Die Eingabe ist zu kurz. Es müssen mindestens %s Zeichen eingegeben werden.',
					maxlength: 'Die Eingabe ist zu lang. Es müssen höchstens %s Zeichen oder weniger eingegeben werden.',
					// length:         'This value length is invalid. It should be between %s and %s characters long.',
					// mincheck:       'You must select at least %s choices.',
					// maxcheck:       'You must select %s choices or fewer.',
					// check:          'You must select between %s and %s choices.',
					equalto: 'Dieses Feld muss dem anderen entsprechen.'
				});

				Parsley.setLocale('de');

				global.configuration.set('parsleyValidatorsInitialized', true);
			}
		},

		/**
		 * Formats separators in a date, i.e. from slashes ('-') to dots ('.')
		 *
		 * @param date {string} - date value that should be formatted
		 * @param currentSeparator {string} - the current separator
		 * @param newSeparator {string} - the new separator
		 */
		formatDateSeparators: function(date, currentSeparator, newSeparator) {
			var dateArray = date.split(currentSeparator);
			return dateArray[2] + newSeparator + dateArray[1] + newSeparator + dateArray[0];
		},

		/**
		 *
		 * Type maxFileSize.
		 *
		 * @param {String} _value
		 * @param {String} maxSize
		 * @param {Object} parsleyInstance
		 * @return {Boolean}
		 *
		 */

		maxFileSize: function () {
			window.Parsley.addValidator('maxFileSize', {
				validateString: function (_value, maxSize, parsleyInstance) {
					if (!window.FormData) {
						return true;
					}
					var files = parsleyInstance.$element[0].files;
					return files.length !== 1 || files[0].size <= maxSize * 1024;
				},
				requirementType: 'integer',
				messages: {
					en: 'This file should not be larger than %s Kb.',
					de: 'Die Datei darf nicht größer sein als %s Kb.'
				}
			});
		},

		/**
		 *
		 * Type maxFileSize.
		 *
		 * @param {String} _value
		 * @param {String} requirement ('pdf','pdf,zip' or 'pdf;zip')
		 * @return {Boolean}
		 *
		 */
		fileExtension: function () {
			window.Parsley.addValidator('fileExtension', {
				validateString: function (_value, requirement) {
					// the value contains the file path, so we can pop the extension
					var requirementArray = requirement.split(/[,;]+/);
					var fileExtension = _value.split('.').pop();

					return $.inArray(fileExtension, requirementArray) > -1;
				},
				messages: {
					en: 'The extension doesn\'t match the required.',
					de: 'Diese Dateiendung wird nicht akzeptiert.'
				}
			});
		},

		/**
		 *
		 * date validation
		 *
		 * @param {String} _value ('DD.MM.YYYY')
		 * @param {String} age
		 * @param {Object} parsleyInstance
		 * @return {Boolean}
		 *
		 */
		minAge: function () {
			var self = this;

			window.Parsley.addValidator('minAge', {
				validateString: function (_value, age, parsleyInstance) {
					if (parsleyInstance.$element[0].type === 'date') {
						_value = self.formatDateSeparators(_value, '-', '.');
					}
					var today = new Date();
					var dateArray = _value.split('.');
					var startDate = new Date(dateArray[2], dateArray[1] - 1, dateArray[0] - 1);
					startDate.setHours(23, 59, 59, 0);
					var ageDifMs = today - startDate.getTime();
					var ageDate = new Date(ageDifMs);
					var difference = Math.abs(ageDate.getUTCFullYear() - 1970);
					age = parseInt(age);
					return difference >= age;
				},
				messages: {
					de: 'Bitte beachten Sie, dass die Bestellung erst ab 18 Jahren möglich ist.'
				}
			});
		},

		/**
		 *
		 * date validation
		 *
		 * @param {String} _value ('DD.MM.YYYY')
		 * @param {String} age
		 * @param {Object} parsleyInstance
		 * @return {Boolean}
		 *
		 */
		excludeDates: function () {
			var self = this;

			window.Parsley.addValidator('excludeDates', {
				validateString: function (_value, age, parsleyInstance) {
					if (parsleyInstance.$element[0].type === 'date') {
						_value = self.formatDateSeparators(_value, '-', '.');
					}
					var dateArray = _value.split('.');
					var date = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
					for (var i = 0; i < global.configuration.data.global.disabledDates.length; i++) {
						if (date.getTime() === global.configuration.data.global.disabledDates[i]) {
							return false;
						}
					}
					return true;
				},
				messages: {
					de: 'Dieses Datum kann nicht gewählt werden.'
				}
			});
		},

		/**
		 *
		 * date validation
		 *
		 * @param {String} _value ('DD.MM.YYYY' or 'YYYY-MM-DD)
		 * @param {String} requirement ('DD.MM.YYYY' or today)
		 *  @param {Object} parsleyInstance
		 * @return {Boolean}
		 *
		 */
		minDate: function () {
			window.Parsley.addValidator('minDate', {
				validateString: function (_value, requirement, parsleyInstance) {
					var valueArray;

					if (parsleyInstance.$element[0].type === 'date') {
						valueArray = _value.split('-');
						_value = valueArray[2] + '.' + valueArray[1] + '.' + valueArray[0];
					}

					valueArray = _value.split('.');
					var valueDate = new Date(valueArray[2], valueArray[1] - 1, valueArray[0]);
					valueDate.setHours(23, 59, 59, 0);
					var theDate;

					if (requirement === 'today') {
						theDate = new Date();
						theDate.setHours(23, 59, 59, 0);
					} else if (requirement === 'tomorrow') {
						theDate = new Date();
						theDate.setDate(theDate.getDate() + 1);
						theDate.setHours(23, 59, 59, 0);
					} else {
						var requirementArray = requirement.split('.');
						theDate = new Date(requirementArray[2], requirementArray[1] - 1, requirementArray[0]);
						theDate.setHours(23, 59, 59, 0);
					}

					return valueDate >= theDate;
				},
				messages: {
					de: 'Datum liegt in der Vergangenheit.'
				}
			});
		},
		/**
		 *
		 * date validation
		 *
		 * @param {String} _value ('DD.MM.YYYY' or 'YYYY-MM-DD)
		 * @param {String} requirement ('DD.MM.YYYY' or today)
		 *  @param {Object} parsleyInstance
		 * @return {Boolean}
		 *
		 */
		maxDate: function () {
			window.Parsley.addValidator('maxDate', {
				validateString: function (_value, requirement, parsleyInstance) {
					var valueArray;

					if (parsleyInstance.$element[0].type === 'date') {
						valueArray = _value.split('-');
						_value = valueArray[2] + '.' + valueArray[1] + '.' + valueArray[0];
					}

					valueArray = _value.split('.');
					var valueDate = new Date(valueArray[2], valueArray[1] - 1, valueArray[0]);
					valueDate.setHours(23, 59, 59, 0);
					var theDate;

					if (requirement === 'today') {
						theDate = new Date();
						theDate.setHours(23, 59, 59, 0);
					} else {
						var requirementArray = requirement.split('.');
						theDate = new Date(requirementArray[2], requirementArray[1] - 1, requirementArray[0]);
						theDate.setHours(23, 59, 59, 0);
					}

					return valueDate <= theDate;
				},
				messages: {
					de: 'Datum liegt in der Zukunft.'
				}
			});
		},

		/**
		 *
		 * date validation
		 *
		 * @param {String} _value ('DD.MM.YYYY')
		 * @param {String} useDate 'true'/'false'
		 * @param {Object} parsleyInstance
		 * @return {Boolean}
		 *
		 */
		date: function () {
			var self = this;

			window.Parsley.addValidator('date', {
				validateString: function (_value, useDate, parsleyInstance) {
					if (parsleyInstance.$element[0].type === 'date') {
						_value = self.formatDateSeparators(_value, '-', '.');
					}
					var regex = /^(((0[1-9]|[12]\d|3[01])\.(0[13578]|1[02])\.((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\.(0[13456789]|1[012])\.((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\.02\.((19|[2-9]\d)\d{2}))|(29\.02\.((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/;
					return regex.test(_value);
				},
				messages: {
					de: 'Bitte geben Sie das Datum im Format TT.MM.JJJJ an.'
				}
			});
		},

		/**
		 *
		 * captchaUrl validation
		 *
		 * @param {String} _value ('DD.MM.YYYY')
		 * @param {String} url
		 * @return {Boolean}
		 *
		 */
		checkCaptchaUrl: function () {
			window.Parsley.addValidator('checkCaptchaUrl', {
				validateString: function (_value, url, parsleyInstance) {

					var response = false;

					$.ajax({
						url: url,
						type: 'get',
						async: false,
						data: {
							text: _value
						},
						success: function (data) {
							if (data.status === true) {
								response = true;
							}
						}
					});
					return response;
				},
				messages: {
					de: 'Captcha Falsch.'
				}
			});
		},

		/**
		 *
		 * iban validation
		 *
		 * @param {String} _value
		 * @return {Boolean}
		 *
		 */
		iban: function () {
			window.Parsley.addValidator('iban', {
				validateString: function (_value) {
					var regex = /[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/;
					return regex.test(_value);
				},
				messages: {
					en: 'Please use a correct IBAN.',
					de: 'Bitte geben Sie den IBAN an.'
				}
			});
		},

		/**
		 *
		 * Weekend Validation
		 *
		 * @param {String} _value
		 * @return {Boolean}
		 *
		 */
		isWeekend: function () {
			var self = this;

			window.Parsley.addValidator('isweekend', {
				validateString: function (_value, requirement, parsleyInstance) {
					if (parsleyInstance.$element[0].type === 'date') {
						_value = self.formatDateSeparators(_value, '-', '.');
					}

					var date = _value.split('.');
					var myDate = new Date();
					myDate.setFullYear(date[2]);
					myDate.setMonth(date[1] - 1);
					myDate.setDate(date[0]);

					if (myDate.getDay() === 6 || myDate.getDay() === 0) {
						return false;
					} else {
						return true;
					}
				},
				messages: {
					de: 'Bitte wählen Sie einen Werktag.'
				}
			});
		},

		/**
		 * Zipcode validation
		 *
		 * @param {String} _value
		 * @return {Boolean}
		 */
		zipcode: function () {
			window.Parsley.addValidator('zipcode', {
				validateString: function(_value) {
					return /^([0]{1}[1-9]{1}|[1-9]{1}[0-9]{1})[0-9]{3}$/.test(_value);
				},
				messages: {
					de: 'Bitte geben Sie eine gültige Postleitzahl ein.'
				}
			});
		},

		/**
		 * Zipcode validation with an array of zips
		 *
		 * @param {String} _value
		 * @return {XMLHttpRequest}
		 */
		zipcodeList: function() {
			var self = this;

			var zipCodesMemo = [];
			var xhrsMemo = [];

			function isInCache(cache, subject) {
				var result = false;
				$.each(cache, function() {
					if (this.inputName == subject) {
						result = true;
					}
				});

				return result;
			}

			function getCachedElement(cache, subject) {
				var hits = $.grep(cache, function(el) {
					return el.inputName === subject;
				});

				return hits[0];
			}

			window.Parsley.addValidator('zipcodeList', {
				validateString: function(zipCode, targetUrl, instance) {

					var inputName = instance.$element.attr('name');
					var currentZipCode = parseInt(zipCode);
					var invalidMsg = instance.$element.data('validation-zipcode-list-message');

					window.Parsley.addMessage('de', 'zipcodeList', invalidMsg);

					// To avoid subsequent requests to the endpoint,
					// we'll store the xhr in a simple cache
					var xhr;
					if (isInCache(xhrsMemo, inputName)) {
						xhr = getCachedElement(xhrsMemo, inputName).xhr;
					} else {
						xhr = $.ajax(targetUrl);
						xhrsMemo.push({
							targetUrl: targetUrl,
							xhr: xhr,
							inputName: inputName
						});
					}

					if (isInCache(zipCodesMemo, inputName)) {
						var cachedZipCodes = getCachedElement(zipCodesMemo, inputName).zipCodes;

						if ($.inArray(currentZipCode, cachedZipCodes) > -1) {
							return $.Deferred().resolve();
						}

						return $.Deferred().reject(invalidMsg);
					}

					return xhr.then(function(zipCodes) {
						zipCodesMemo.push({
							inputName: inputName,
							zipCodes: zipCodes
						});

						if ($.inArray(currentZipCode, zipCodes) === -1) {
							return $.Deferred().reject(invalidMsg);
						} else {
							return $.Deferred().resolve();
						}
					});
				}
			});
		}
	};

	global.configuration.set('initParsleyValidators', methods);

})(jQuery);
